import Service from '@/utils/request';
/**
 * 获取外卖订单列表
 *
 * @param params 请求参数对象
 * @returns Promise<any> 包含配送订单列表的Promise对象
 */
export const fetchTakeoutOrderList = (params) => Service.get('/biz/takeout/order/list', {
        params: {
            ...params,
            appCode: 'WL',
        },
    });
/**
 * 获取未处理外卖订单列表(未被打包的订单)
 *
 * @param params 请求参数对象
 * @returns Promise<any> 包含配送订单列表的Promise对象
 */
export const fetchUnhandledTakeoutOrderList = (params) => Service.get('/biz/takeout/order/untakedList', {
        params: {
            ...params,
            appCode: 'WL',
        },
    });
/**
* 确认接单
*
* @param id 订单ID
* @returns 返回外卖订单详情
*/
export const fetchTakeoutTake = (id) => Service.post('/biz/takeout/order/take', {
            id,
            appCode: 'WL'
    });
/**
* 获取外卖订单信息
*
* @param {string} id - 外卖订单ID
* @returns {Promise<any>} - 返回一个Promise对象，包含外卖订单信息
*/
export const fetchTakeoutOrderInfo = (id) => Service.get(`/biz/takeout/order/${id}`, {
            appCode: 'WL'
    });
/**
* 拆分订单
*
* @param {string} params.id - 订单ID
* @param {number} params.splitNum - 拆分数量
* @returns 返回拆分后的订单列表
*/
export const fetchSplitTakeoutOrder = (params={}) => Service.post(`/biz/takeout/order/splitOrder`, {
            ...params,
            appCode: 'WL'
        
    });
/**
 * 取消外卖订单
 * @param {*} id 
 * @returns 
 */
export const fetchCancelTakeoutOrder = (id) => Service.post(`/biz/takeout/order/cancel`, {
            id,
            appCode: 'WL'
        
    });



/**
* 获取配送订单列表
*
* @param params 请求参数
* @returns 返回配送订单列表
*/
export const fetchDeliveryOrderList = (params) => Service.get('/biz/delivery/order/list', {
        params: {
            ...params,
            appCode: 'WL',
        },
    });
/**
* 保存配送订单
*
* @param params 请求参数对象
* @returns 返回请求结果
*/
export const fetchDeliveryOrderSave = (params) => Service.post('/biz/delivery/order/create', {
        
            ...params,
            appCode: 'WL',
    
    });
/**
* 删除配送订单
*
* @param id 配送订单ID
* @returns 删除结果
*/
export const fetchDeleteDeliveryOrder= (id) => Service.delete(`/biz/delivery/order/${id}`, {
            appCode: 'WL',
    
}); 
/**
* 获取配送订单信息
*
* @param {string} id - 订单ID
* @returns {Promise} 返回包含配送订单信息的Promise对象
*/
export const fetchDeliveryOrderInfo = (id) => Service.get(`/biz/delivery/order/${id}`, {
            appCode: 'WL',
    
    });
/**
* 获取配送订单日志
*
* @param id 配送订单ID
* @returns 返回配送订单日志数据
*/
export const fetchDeliveryOrderLog = (id) => Service.get(`/biz/delivery/order/logList`, {
    params:{ id,  appCode: 'WL'}
   
  
    
    });
/**
* 添加配送订单商品（外卖单）项
*
* @param params 请求参数对象 {orderId: 配送订单ID, bizId: 外卖订单ID,bizType:'T'//固定值T(外卖单)货品类型,isPart:false(是否为拆分订单项，默认false,true为拆分订单项)}
* @returns 返回请求结果
*/
export const fetchDeliveryOrderAddItem = (params) => Service.post('/biz/delivery/order/addItem', {
            ...params,
            appCode: 'WL',
    });
/**
* 从配送订单中移除货物项（外卖单）项
*
* @param params 请求参数对象 {orderId: 配送订单ID, bizId: 外卖订单ID,bizType:'T'//固定值T(外卖单)货品类型,isPart:false(是否为拆分订单项，默认false,true为拆分订单项)}
* @returns Promise 返回Promise对象，解析为API响应数据
*/
export const fetchDeliveryOrderRemoveItem = (params) => Service.post('/biz/delivery/order/removeItem', {
            ...params,
            appCode: 'WL',
    });
/**
* 确认配送订单装载完成（无人机装载完成）
*
* @param params 请求参数对象 {orderId: 配送订单ID, droneId: 无人机ID}
* @returns 返回请求结果
*/
export const fetchLoadComplete = (params) => Service.post('/biz/delivery/order/loaded', {
            ...params,
            appCode: 'WL',
    });
/**
* 获取物流订单状态
*
* @param id 物流订单ID
* @returns 返回物流订单状态
*/
export const fetchDeliveryOrderStatus = (id) => Service.get('/biz/delivery/order/status', {
        params: {
            id,
            appCode: 'WL',
        },
    });
 /**
     * 获取无人机选项列表
     * @param {*} params 请求参数对象
     * @returns 
     */
export const    fetchDroneOptionList = (params={}) => Service.get(`/fcs/drone/optionList`,{...params, appCode: 'WL'})



export default {
  fetchTakeoutOrderList,
  fetchUnhandledTakeoutOrderList,
  fetchTakeoutTake,
  fetchTakeoutOrderInfo,
  fetchDeliveryOrderList,
  fetchDeliveryOrderSave,
  fetchDeleteDeliveryOrder,
  fetchDeliveryOrderInfo,
  fetchDeliveryOrderAddItem,
  fetchDeliveryOrderRemoveItem,
  fetchDroneOptionList,
  fetchLoadComplete,
  fetchDeliveryOrderLog,
  fetchDeliveryOrderStatus,
  fetchSplitTakeoutOrder,
  fetchCancelTakeoutOrder,
};